import { render, staticRenderFns } from "./ProSelect.vue?vue&type=template&id=3ef94d06&scoped=true&"
import script from "./ProSelect.vue?vue&type=script&lang=js&"
export * from "./ProSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProSelect.vue?vue&type=style&index=0&id=3ef94d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef94d06",
  null
  
)

export default component.exports